import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SectionTitle from '@src/components/SectionTitle';
import { EMPLOYMENT_TYPES } from '@src/constants';
import './styles.scss';

export default class EmploymentType extends PureComponent {
  static propTypes = {
    employmentType: PropTypes.string,
    setEmploymentType: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = { currentType: props.employmentType };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.employmentType !== this.state.currentType) {
      this.setState({ currentType: nextProps.employmentType });
    }
  }

  render() {
    const { currentType } = this.state;

    return (
      <div className="create-funnel-employment-types">
        <SectionTitle subtitle="What type of position are you looking to fill." title="Employment type" />

        <div className="grid-selection">
          {Object.values(EMPLOYMENT_TYPES).map(type => {
            return (
              <button
                className={classnames('grid-selection-item', type.key === currentType && 'selected')}
                key={type.key}
                onClick={() => this.props.setEmploymentType(type.key)}
              >
                <span>{type.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }
}
